export class Shape {
    x: number;
    y: number;
    srid: number = 0;

    constructor(x: number = 0, y: number = 0) {
        this.x = x;
        this.y = y;
    }
}